export default "__VITE_ASSET__HxTlC1bM__"